// import { globalPut } from '../index';
import { post } from "../index";

export const uploadDisciplineCsv = body => {
  return post('/discipline/csv', body, true);
}
